<template>
    <div class="bottomMsg">
        <div class="bottomMsgBox">
            <div class="bottomMsgBoxLeft">
                <p class="phone">0771-3859999</p>
                <p class="work">周一至周六 9：00-18：00</p>
                <ul class="code">
                    <li>
                        <img src="@/assets/home/qrcode/gongzonghao.png" alt="">
                        <p>关注小易公众号</p>
                    </li>
                    <li>
                        <img src="@/assets/home/qrcode/gongzonghao.png" alt="">
                        <p>联系客服微信</p>
                    </li>
                </ul>
            </div>
            <div class="bottomMsgBoxRight">
                <ul>
                    <li v-for="(item,index) in tabData" :key="index">
                        <p class="tabTitle">{{item.title}}</p>
                        <p class="tabSubtitle" v-for="(list,i) in item.pagelist" :key="i">{{list}}</p>
                    </li>
                </ul>
            </div>
            <div class="website">
                <a href="https://beian.miit.gov.cn/" style="color: #A2A5AC;text-decoration:none; margin-right: 30px; " target="_blank">桂ICP备18000700号-2</a>
                 | Copyright ◎ 2016-2050广西小易科技有限公司 版权所有
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"bottomMsgBox",
    data(){
        return {
            tabData:[
                {
                    title:"网站建设",
                    pagelist:['企业官网定制','品牌官网定制','电商网站定制','响应式网站定制','营销型网站定制','外贸网站定制']
                },
                {
                    title:"小程序开发",
                    pagelist:['企业小程序','商城小程序','餐饮小程序','酒店小程序','社交小程序','其他小程序']
                },
                {
                    title:"APP开发",
                    pagelist:['IOS开发','安卓开发','混合应用开发','H5应用开发']
                },
                {
                    title:"代运营",
                    pagelist:['微信代运营','网站推广','新媒体运营','海外运营','数字互动运营']
                },
            ]
        }
    }
}
</script>

<style lang="scss">
    .bottomMsg{
        width: 100%;
        background: #161E30;
        .bottomMsgBox{
            padding: 80px 0 40px;
            width: 1200px;
            height: 570px;
            display: flex;
            margin:0 auto;
            flex-wrap: wrap;
            .bottomMsgBoxLeft{
                margin-right: 184px;
                .phone{
                    font-size: 34px;
                    font-weight: bold;
                    color: #FFFFFF;
                    margin-bottom: 4px;
                }
                .work{
                    font-size: 14px;
                    font-weight: 400;
                    color: #A2A5AC;
                    margin-bottom: 54px;
                }
                .code{
                    display: flex;
                    text-align: center;
                    li:nth-child(1){
                        margin-right: 48px;
                    }
                    img{
                        width: 136px;
                    }
                    p{
                        font-size: 14px;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-top: 12px;
                    }
                }
            }
            .bottomMsgBoxRight{
                ul{
                    display: flex;
                    .tabTitle{
                        font-size: 20px;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-bottom: 32px;
                    }
                    .tabSubtitle{
                        font-size: 16px;
                        font-weight: 400;
                        color: #A2A5AC;
                        margin-bottom: 20px;
                        cursor: pointer;
                    }
                    li:nth-child(-n+3){
                        margin-right: 90px;
                    }
                }

            }
            .website{
                flex: 0 0 100%;
                border-top: 1px solid #A2A5AC;
                font-size: 16px;
                font-weight: 400;
                color: #A2A5AC;
                padding-top: 30px;
                text-align: center;
            }
        }
    }
</style>
